var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIndarklinkedn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 25.4882H7.99998V8.68454H13.3333V11.4851C14.4701 9.96618 16.1941 9.06062 18.0333 9.01641C21.3407 9.0357 24.0096 11.8624 24 15.336V25.4882H18.6666V16.0361C18.4533 14.4715 17.1756 13.3106 15.6706 13.3139C15.0123 13.3358 14.391 13.6385 13.9499 14.1522C13.5088 14.6659 13.2862 15.3462 13.3333 16.0361V25.4882ZM5.33332 25.4882H0V8.68454H5.33332V25.4882ZM2.66666 5.88393C1.1939 5.88393 0 4.63006 0 3.08332C0 1.53659 1.1939 0.282715 2.66666 0.282715C4.13942 0.282715 5.33332 1.53659 5.33332 3.08332C5.33332 3.82609 5.05237 4.53844 4.55228 5.06365C4.05218 5.58887 3.3739 5.88393 2.66666 5.88393Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIndarklinkedn);
export default __webpack_public_path__ + "static/media/LinkedIndarklinkedn.2165475139ac84227ff281e1995b8941.svg";
export { ForwardRef as ReactComponent };